import { createFileRoute } from '@tanstack/react-router';
import { makeTableSearchValidator } from '../lib/table-filter.js';
import { ProjectsPage } from './projects.js';

export const Route = createFileRoute('/$workspaceSlug/projects')({
  component: ProjectsPage,
  validateSearch: makeTableSearchValidator({ view: 'uuid' }),
});
